import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import Help from '../../Common/Help/Help';
import deleteIcon from '../../../images/icons/delete.svg';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import './PriceStream.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

const DragHandle = SortableHandle(() => <div className="sort-handle">::</div>); // This can be any component you want

const SortableItem = SortableElement(({index, value, event, handleSortableInputs, deleteRow}) => {
	return (
		<tr>
			<td className="text-center">
				{value.delete && (
					<DragHandle />
				)}  
			</td>
			<td>
                <div className={"showtix-form__group " + (value.validation.valid === false ? 'showtix-form__error' : '')}>
					<div className="showtix-form__input">
						<input 
							className="showtix-input"
							type="text"
							object="prices"
							name="desc"
							id={value.id}
							value={value.desc}
                            onChange={handleSortableInputs}	
							validation="(^(?!\s*$).+)"
							type="Live Stream"
						/>
					</div>
				</div>	
			</td>
			<td>
                <div className={"showtix-form__group " + (value.validation.valid === false ? 'showtix-form__error' : '')}>
					<div className="showtix-form__input showtix-form__money">
						<input
							className="showtix-input"
							type="number"
							object="prices"
							name="amount"
							id={value.id}
							value={value.amount === 0 ? '0' : value.amount}
							onChange={handleSortableInputs}
							validation="(^\$?\d+((,\d{3})+)?(\.\d+)?$)"
							readonly={!value.isNew ? 'readonly' : false}
							type="Live Stream"
						/>
					</div>
				</div>	
			</td>
            <td className="text-right">
				{value.delete && 
					<button
                        className="showtix-button showtix-button__simple"
                        object="prices"
						id={value.id}
						onClick={deleteRow}
					>
						<img 
							className="delete-icon" 
							src={deleteIcon} 
							alt="delete icon" 
						/>
					</button>
				}
			</td>
		</tr>
	);
});

const SortableItemFees = SortableElement(({index, value, event, handleSortableInputs, deleteRow}) => {
	return (
		<tr>
			<td className="text-center">
				{value.delete && (
					<DragHandle />
				)}  
			</td>
			<td>
                <div className={"showtix-form__group " + (value.validation.valid === false ? 'showtix-form__error' : '')}>
					<div className="showtix-form__input">
						<input 
							className="showtix-input"
							type="text"
							object="fees"
							name="desc"
							id={value.id}
							value={value.desc}
                            onChange={handleSortableInputs}	
							validation="(^(?!\s*$).+)"
							type="Live Stream"
						/>
					</div>
				</div>	
			</td>
			<td>
                <div className={"showtix-form__group " + (value.validation.valid === false ? 'showtix-form__error' : '')}>
					<div className="showtix-form__input showtix-form__money">
						<input
							className="showtix-input"
							type="number"
							object="fees"
							name="amount"
							id={value.id}
							value={value.amount === 0 ? '0' : value.amount} 
							onChange={handleSortableInputs}
							validation="(^\$?\d+((,\d{3})+)?(\.\d+)?$)"
							type="Live Stream"
						/>
					</div>
				</div>	
			</td>
            <td className="text-right">
				{value.delete && 
					<button
                        className="showtix-button showtix-button__simple"
                        object="fees"
						id={value.id}
						onClick={deleteRow}
					>
						<img 
							className="delete-icon" 
							src={deleteIcon} 
							alt="delete icon" 
						/>
					</button>
				}
			</td>
		</tr>
	);
});

const SortableList = SortableContainer(({items, event, handleSortableInputs, deleteRow}) => {
	return (
		<tbody>
			{items.map((value, index) => (
				<SortableItem 
					key={`item-${index}`} 
					index={index} 
					value={value}
					event={event}
					handleSortableInputs={handleSortableInputs}
					deleteRow={deleteRow} 
				/>
			))}
		</tbody>
	);
});

const SortableListFees = SortableContainer(({items, event, handleSortableInputs, deleteRow}) => {
	return (
		<tbody>
			{items.map((value, index) => (
				<SortableItemFees 
					key={`item-${index}`} 
					index={index} 
					value={value}
					event={event}
					handleSortableInputs={handleSortableInputs}
					deleteRow={deleteRow} 
				/>
			))}
		</tbody>
	);
});

class PriceStream extends Component {
	constructor(props) {
        super(props);
        this.state = {  
            videos: [],
        };
    }

    componentDidMount() {
        this.getAdminVideos();
	}

	getAdminVideos = () => {
        const getVideos = async () => {
            try {
                const videosResponse = await getVideosAPI();
                console.log('videosResponse: ', videosResponse);
                if (videosResponse.data) {
                    const videos = videosResponse.data;
                    this.setState({
                        videos,
                    });
                }
            } catch (error) {
                console.log('error', error);
            }
        };

        async function getVideosAPI() {
            return await ApiRequest('/admin/videos', {
                method: 'GET',
            });
        }
        getVideos();
    }
	
	render() { 
		const videos = this.state.videos;
		let createEventUrl = 'https://www.youtube.com/channel/UC30U07xVY2zbooskb9VpRzg/videos';
		let compUrl = 'https://www.youtube.com/channel/UC30U07xVY2zbooskb9VpRzg/videos';
		let pricingUrl = 'https://www.youtube.com/channel/UC30U07xVY2zbooskb9VpRzg/videos';
        if (videos.length > 0) {
			videos.forEach((video) => {
				if (video.title.includes('Creating New Event')) {
					createEventUrl = `https://www.youtube.com/watch?v=${video.youtube_id}`;
				}
				if (video.title.includes('Creating Comp Tickets')) {
					compUrl = `https://www.youtube.com/watch?v=${video.youtube_id}`;
				}
				if (video.title.includes('Customize Pricing')) {
					pricingUrl = `https://www.youtube.com/watch?v=${video.youtube_id}`;
				}
			});
		}
		return ( 
			<div className="showtix-section showtix-background__primary-2">
				<div className="container">
					<div className="row">
						<div className="col-12 col-lg-9">
							<h1>{strings.title}</h1>
							<div className="row">
								<div className="col-12">
									<div className="showtix-form__group">
										<div className="table-responsive">
											<table className="showtix-table" id="prices" width="100%">
												<thead>
													<tr>
														<th></th>
														<th>{strings.priceName}</th>
														<th className="text-center">{strings.title}</th>
                                                        <th style={{ width: 50 }}></th>
													</tr>
												</thead>
												<SortableList 
													items={this.props.event.prices}
													event={this.props.event}
                                                    onSortEnd={this.props.onSortEnd}
                                                    onSortStart={this.props.onSortStart}
													handleSortableInputs={this.props.handleSortableInputs}
                                                    deleteRow={this.props.deleteRow}
                                                    lockToContainerEdges={true}
                                                    lockAxis= 'y'
													useDragHandle={true} />
											</table>
										</div>
									</div>
								</div>
							</div>
						</div>

						{ strings.helps &&
							<div className="col-12 col-lg-3">
								<div className="showtix-box">
									<div className="showtix-padder">
										<h3 className="showtix-box__title">{strings.video.title}</h3>
										<p><a href={createEventUrl} target="_blank">{strings.video.content1}</a></p>
										<p><a href={compUrl} target="_blank">{strings.video.content2}</a></p>
										<p><a href={pricingUrl} target="_blank">{strings.video.content3}</a></p>
									</div>	
								</div>
								{strings.helps.map((help, i) =>
									<Help help={help} key={i} /> 
								)}
							</div>	
						}
					</div>

					<div className="row">
						<div className="col-12 col-lg-9">
							<h1>{strings.customFees}</h1>
							<div className="row">
								<div className="col-12">
									<div className="showtix-form__group">
										<div className="table-responsive">
											<table className="showtix-table" id="prices" width="100%">
												<thead>
													<tr>
														<th></th>
														<th>{strings.feeName}</th>
														<th className="text-center">{strings.feeAmount}</th>
                                                        <th style={{ width: 50 }}></th>
													</tr>
												</thead>
												<SortableListFees 
													items={this.props.event.fees}
													event={this.props.event}
                                                    onSortEnd={this.props.onSortEnd}
                                                    onSortStart={this.props.onSortStart}
													handleSortableInputs={this.props.handleSortableInputs}
                                                    deleteRow={this.props.deleteRow}
                                                    lockToContainerEdges={true}
                                                    lockAxis= 'y'
													useDragHandle={true} />
											</table>
										</div>
									</div>
								</div>
							</div>
						</div>

                        { strings.tips &&
						<div className="col-12 col-lg-3">
                            {strings.tips.map((help, i) =>
								<Help help={help} key={i} />
                            )}
						</div>
                        }
					</div>
				</div>
			</div>
		)
	}
}

PriceStream.propTypes = {
    event: PropTypes.shape({
        prices: PropTypes.array,
    }),
    onSortEnd: PropTypes.func,
    onSortStart: PropTypes.func,
    handleSortableInputs: PropTypes.func,
    deleteRow: PropTypes.func
}
 
export default PriceStream;


// WEBPACK FOOTER //
// ./src/components/CreateEvent/PriceStream/PriceStream.js